"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientHttpHeaders = createClientHttpHeaders;
const constants_1 = require("@daytrip/constants");
function createClientHttpHeaders({ appName, deviceName, platform, platformVersion, version, lang, }) {
    const headers = {
        lang,
        [constants_1.HTTP_HEADER_CLIENT]: `${appName} ${version}`,
    };
    if (platform) {
        headers[constants_1.HTTP_HEADER_CLIENT_PLATFORM] = platform;
    }
    if (platformVersion) {
        headers[constants_1.HTTP_HEADER_CLIENT_PLATFORM_VERSION] = platformVersion;
    }
    if (deviceName) {
        headers[constants_1.HTTP_HEADER_CLIENT_DEVICE] = deviceName;
    }
    return headers;
}
//# sourceMappingURL=create-client-http-headers.js.map